import { MethodPropertyModifySettingsForm } from "components/Forms/MethodPropertyModifySettingForm/MethodPropertyModifySettingsForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface MethodRequestHeaderSettingDrawerProps {
    name: number;
    parentName: number;
}

export const MethodRequestHeaderSettingDrawer: FC<MethodRequestHeaderSettingDrawerProps> = ({ name, parentName }) => {
    const { t } = usePaldockTranslation("drawers.method-request-header-setting");
    const drawerId = DrawerId.MethodPropertyHeaderSetting;

    const headersPath = `methods.${parentName}.requestConfig.headers.${name}` as const;

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title", { name })} />}
            searchParamsToClean={[`${drawerId}-id`, `${drawerId}-propertyType`, `${drawerId}-parentName`]}
        >
            <MethodPropertyModifySettingsForm propertyPath={headersPath} />
        </Drawer>
    );
};
